export default __webpack_public_path__ + "static/media/selection_bg.a42a50d4.svg";